<template>
  <v-data-table
    :headers="headers"
    :items="canningProcesses"
    class="elevation-1"
    :loading="isLoading"
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-btn
          color="success"
          data-cy="CanningProcess-button-new"
          @click="$router.push({
            name: 'processing-EditCanningProcess'
          })"
        >
          {{ $t('common.buttons.new') }}
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon
        small
        class="mr-2"
        :data-cy="`button-CanningProcess-edit-${item.id}`"
        @click="$router.push({
          name: 'processing-EditCanningProcess',
          query: {id: item.id}
        })"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="remove(item)"
        color="danger"
        :data-cy="`button-CanningProcess-remove-${item.id}`"
      >
        mdi-delete
      </v-icon>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListCanningProcess',
  module: 'CanningProcess',
  mixins: [loading],
  computed: {
    /** Vuex states
     */
    ...mapState('canningProcesses', ['canningProcesses']),
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: this.$$t('productionCode'),
          value: 'productionCode',
        },
        {
          text: this.$$t('batchCodes'),
          value: 'batchCodes',
        },
        {
          text: this.$$t('fillerOpened'),
          value: 'fillerOpened',
        },
        {
          text: this.$$t('weigherVerified'),
          value: 'weigherVerified',
        },
        {
          text: this.$$t('codingSameAsProductionCode'),
          value: 'codingSameAsProductionCode',
        },
        {
          text: this.$$t('ingoingTemperature'),
          value: 'ingoingTemperature',
        },
        {
          text: this.$$t('seamingDone'),
          value: 'seamingDone',
        },
        {
          text: this.$$t('preretordTemp'),
          value: 'preretordTemp',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_canningProcesses();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('canningProcesses', ['LOAD_canningProcesses', 'DELETE_canningProcess']),
    /** Delete CanningProcess from the collection
     */
    async remove(CanningProcess) {
      this.isLoading = true;
      await this.DELETE_CanningProcess(CanningProcess);
      this.isLoading = false;
    },
  },
};
</script>

<docs>
# CanningProcess example

'''js
<CanningProcess />
'''
</docs>
